import './EnhancedEventViewReleaseEvent.scss';
import { useTranslation } from 'react-i18next';
import { eventActivityType } from '../../../constants/myBlockMonth';
import { getDateInWeekDayMonthDateFormat } from '../../../helpers/dateHelpers';
import { formatNumToTime } from '../../../helpers/timeHelpers';

function EnhancedEventViewReleaseEvent({ event, activityType }) {
    const { t } = useTranslation();

    return (
        <>
            <div className={activityType === eventActivityType.PAIRING ? 'c-release-event-details--pairing' : 'c-release-event-details'}>
                <div className={activityType === eventActivityType.PAIRING ? 'c-release-indicator--pairing' :'c-release-indicator'}>
                    <p className='indicator__value'>{t('myBlockMonth.release')}</p>
                </div>
                <div className={activityType === eventActivityType.PAIRING ? 'c-main--pairing' :'c-main'}>
                    <div className={activityType === eventActivityType.PAIRING ? 'c-start--pairing' :'c-start'}>
                        <p className='start__label'>{t('myBlockMonth.start')}</p>
                        <div className={activityType === eventActivityType.PAIRING ? 'c-date-time--pairing' :'c-date-time'}>
                            <p className={activityType === eventActivityType.PAIRING ? 'date-time__date--pairing' :'date-time__date'}>{getDateInWeekDayMonthDateFormat(new Date(event?.start_date + " 00:00"))}</p>
                            <p className={activityType === eventActivityType.PAIRING ? 'date-time__time--pairing' :'date-time__time'}>{formatNumToTime(event?.checkIn?.value)} ET</p>
                        </div>
                    </div>
                    <div className={activityType === eventActivityType.PAIRING ? 'c-end--pairing' :'c-end'}>
                        <p className='start__label'>{t('myBlockMonth.end')}</p>
                        <div className={activityType === eventActivityType.PAIRING ? 'c-end--pairing_value' :'c-end_value'}>
                            <p className={activityType === eventActivityType.PAIRING ? 'ev_specialEvent_rp_endDateValue' :'ev_specialEvent_release_endDateValue'}>{getDateInWeekDayMonthDateFormat(new Date(event?.end_date + " 00:00"))}</p>
                            <p className={activityType === eventActivityType.PAIRING ? 'ev_specialEvent_rp_endTimeValue' :'ev_specialEvent_release_endTimeValue'}>{formatNumToTime(event?.checkOut?.value)} ET</p>
                        </div>     
                    </div>
                </div>
                <div className={activityType === eventActivityType.PAIRING ? 'ev_specialEvent_rp_durationDetails' :'ev_specialEvent_release_durationDetails'}>
                    <p className={activityType === eventActivityType.PAIRING ? 'ev_specialEvent_rp_durationLabel' :'ev_specialEvent_release_durationLabel'}>{t('myBlockMonth.duration')}</p>
                    <p className={activityType === eventActivityType.PAIRING ? 'ev_specialEvent_rp_durationValue' :'ev_specialEvent_release_durationValue'}>{event.duration.split('(')[0]}</p>
                </div>
            </div>
            {activityType === eventActivityType.PAIRING ? <div className="ev_specialEvent_rp_divider"></div> :''}
        </>
    );
}

export default EnhancedEventViewReleaseEvent;